import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeroIcon } from '../../../../assets/icons/hero/hero';

@Component({
  selector: 'sheba-best-hospital',
  templateUrl: 'best-hospital.component.html',
  styleUrls: ['best-hospital.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [HeroIcon],
  host: {
    class: 'flex w-full place-content-center overflow-hidden'
  }
})
export class ShebaBestHospitalComponent {
  bestHospitalBannerTitle = input<string>();
  bestHospitalBannerDescription = input<string>();
}
